import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import Message from 'react-icons/lib/fa/comment';
import Phone from 'react-icons/lib/fa/phone';
import Email from 'react-icons/lib/fa/envelope';
import Info from 'react-icons/lib/fa/info';

class ContactUs extends Component {
  constructor(props){
    super()
    this.state = {
    }
  }
  openMessageDiv = () => {
    var footer = document.getElementById("footer")
    footer.click()
  }
  render(){
    return (
      <div className="contactDiv">
        <a onClick={this.openMessageDiv}>
          <Message className='fa-lg contactIcon'/>
          <h3 className="contactLinks">Message</h3>
        </a>
        <a href="tel:844-438-7743">
          <Phone className='fa-lg contactIcon'/>
          <h3 className="contactLinks">Call</h3>
        </a>
        <a  href="mailto:support@getspiffy.com">
          <Email className='fa-lg contactIcon'/>
          <h3 className="contactLinks">Email</h3>
        </a>
        <a href={"https://www.getspiffy.com/appfaq"}>
          <Info className='fa-lg contactIcon'/>
          <h3 className="contactLinks">FAQ</h3>
        </a>
      </div>
    )
  }
}
export default ContactUs



// WEBPACK FOOTER //
// ./src/Components/ContactUs.js